import Main from '@/pages/Main';


export const routes = [
  {path: '/', component: Main},
]
